import React from 'react';
import './Card.css';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    noPadding?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ className = '', children, noPadding = false, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={`qube-card ${noPadding ? 'qube-card-no-padding' : ''} ${className}`}
                {...props}
            >
                {children}
            </div>
        );
    }
);
Card.displayName = 'Card';

export const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className = '', children, ...props }, ref) => {
        return (
            <div ref={ref} className={`qube-card-header ${className}`} {...props}>
                {children}
            </div>
        );
    }
);
CardHeader.displayName = 'CardHeader';

export const CardTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
    ({ className = '', children, ...props }, ref) => {
        return (
            <h3 ref={ref} className={`qube-card-title ${className}`} {...props}>
                {children}
            </h3>
        );
    }
);
CardTitle.displayName = 'CardTitle';

export const CardBody = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className = '', children, ...props }, ref) => {
        return (
            <div ref={ref} className={`qube-card-body ${className}`} {...props}>
                {children}
            </div>
        );
    }
);
CardBody.displayName = 'CardBody';

export const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className = '', children, ...props }, ref) => {
        return (
            <div ref={ref} className={`qube-card-footer ${className}`} {...props}>
                {children}
            </div>
        );
    }
);
CardFooter.displayName = 'CardFooter';
